/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../../static/scss/resources/default.variables.scss';
@import '../../../../static/scss/resources/default.style.scss';


/* To make font same as Query tool in messages tab */
.messages {
    white-space: pre-wrap;
    font-family: $font-family-editor;
    padding-top: 5px;
    padding-left: 10px;
    overflow: auto;
    height: 100%;
    font-size: 0.925em;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
}

.debugger-args {
    display: block;
    width: 100%;
    height: 100%;
    overflow: auto;
}
